let Navbar = {};

Navbar.init = function(){
    let body = document.body;
    let navbar = document.querySelector('[data-module="navbar"]');
    let hover = document.querySelector('[data-module="navbar"] .nav__hover');
    let button = document.querySelector('.button--menu');

    navbar.querySelectorAll('.nav__item').forEach((item) => {        

        item.addEventListener('mouseenter', (e) => {
            hover.style.opacity = 1;
            hover.style.width = e.target.offsetWidth + 'px';
            hover.style.left = e.target.offsetLeft + 'px';
        });

        item.addEventListener('mouseleave', () => {
            hover.style.opacity = 0;
        })
    });

    button.addEventListener('click', function() {
        button.classList.toggle("button--menu--open");
        navbar.classList.toggle("js-opened");
        body.classList.toggle("js-freeze");
    });
}

Navbar.init();

module.exports = Navbar;
